// extracted by mini-css-extract-plugin
export default {"guide":"Guide_guide__f7ucD","handler":"Guide_handler__9zHFG","vertical":"Guide_vertical__qddNk","selected":"Guide_selected__hyOLW"};